var sizeMap = new Map([["xxl", 200], ["xl", 80], ["l", 48], ["m", 36], ["s", 24], ["xs", 18]]);
var borderRadiusMap = new Map([["xxl", 8], ["l", 4], ["m", 4], ["s", 2], ["xs", 2]]);
var selectedBorderWidthMap = new Map([["l", 2], ["m", 2], ["s", 1.5], ["xs", 1]]);
var selectedBorderRadiusMap = new Map([["l", 2], ["m", 2], ["s", 2], ["xs", 1]]);
var fontSizeMap = new Map([["xxl", 140], ["xl", 40], ["l", 32], ["m", 24], ["s", 17], ["xs", 12]]);
var fontWeightMap = new Map([["xxl", function (theme) {
  return theme.font.medium;
}], ["l", function (theme) {
  return theme.font.medium;
}], ["m", function (theme) {
  return theme.font.medium;
}], ["s", function (theme) {
  return theme.font.medium;
}], ["xs", function (theme) {
  return theme.font.regular;
}]]);

export { borderRadiusMap, fontSizeMap, fontWeightMap, selectedBorderRadiusMap, selectedBorderWidthMap, sizeMap };
